function convertSecondsToTime(seconds: number) {
  let formattedTime = "";

  const fixedSeconds = Number(seconds.toFixed());
  const hours = Math.floor(fixedSeconds / 3600);
  const minutes = Math.floor((fixedSeconds % 3600) / 60);
  const remainingSeconds = fixedSeconds % 60;

  if (hours > 0) {
    formattedTime += hours.toString().padStart(2, "0") + ":";
  }
  formattedTime +=
    minutes.toString().padStart(2, "0") +
    ":" +
    remainingSeconds.toString().padStart(2, "0");

  return formattedTime;
}

function isHappeningNow(start_time: Date, end_time: Date) {
  const startTime = start_time;
  const endTime = end_time;
  const currentTime = new Date();

  const durationInMilli = () => {
    return endTime.getTime() - startTime.getTime();
  };

  return (
    currentTime < new Date(startTime.getTime() + durationInMilli()) &&
    currentTime > new Date(startTime.getTime())
  );
}

function secondsFromNow(date: string): number {
  const inputDate = new Date(date);
  const now = new Date();

  // Calculate difference in milliseconds
  const diffMs = inputDate.getTime() - now.getTime();

  // Convert to seconds and round
  return Math.round(diffMs / 1000);
}

function formatTimeUntilEvent(eventDate: string): {
  timeString: string;
  hasStarted: boolean;
} {
  const now = new Date();
  const event = new Date(eventDate);
  const diff = event.getTime() - now.getTime();
  const absDiff = Math.abs(diff);
  const hasStarted = diff < 0;

  const days = Math.floor(absDiff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (absDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((absDiff % (1000 * 60 * 60)) / (1000 * 60));

  let timeString: string;

  if (days > 0) {
    timeString = `${days}d`;
  } else if (hours > 0) {
    timeString = `${hours}h ${minutes}m`;
  } else {
    timeString = `${minutes}m`;
  }

  return {
    timeString,
    hasStarted,
  };
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

function getDateInLocalTimezone(date: Date) {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: timeZone,
    hour: "numeric",
    minute: "2-digit",
    month: "short",
    day: "numeric",
    timeZoneName: "short",
  });

  const parts = Object.fromEntries(
    formatter.formatToParts(new Date(date)).map((p) => [p.type, p.value]),
  );

  return parts;
}

export {
  convertSecondsToTime,
  isHappeningNow,
  secondsFromNow,
  formatTimeUntilEvent,
  getDateInLocalTimezone,
};
